export enum GoStationClassType {
    Shared = 'Shared',
    Exclusive = 'Exclusive',
}

export const GoStationClassTypeToLabelMapping = {
    [GoStationClassType.Shared]: 'Shared',
    [GoStationClassType.Exclusive]: 'Exclusive',
};
